(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ia-section-announcement-2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const marq = document.getElementById('ia-sections-marq');
    const orig = document.getElementById('ia-sections-orig');
    const clone = orig.cloneNode(true);
    clone.id = 'ia-sections-clone';
    marq.appendChild(clone);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ia-section-faq-3"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const faqSection = document.getElementById('ia-section-faq-3-{{ section_id }}');

    // Popular questions click tracking
    const popularLinks = faqSection.querySelectorAll('.ia-section-faq-3__popular-link');
    popularLinks.forEach((link) => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          // Expand the FAQ item
          const checkbox = targetElement.querySelector('.ia-section-faq-3__toggle');
          if (checkbox) {
            checkbox.checked = true;
          }

          // Track the click (for analytics)
          if (typeof window.analytics !== 'undefined') {
            window.analytics.track('FAQ Popular Question Clicked', {
              question: this.textContent.trim(),
              section: 'Popular Questions',
            });
          }

          // Scroll to the item
          window.scrollTo({
            top: targetElement.offsetTop - 100,
            behavior: 'smooth',
          });
        }
      });
    });

    // Track FAQ expansions for analytics
    const faqToggles = faqSection.querySelectorAll('.ia-section-faq-3__toggle');
    faqToggles.forEach((toggle) => {
      toggle.addEventListener('change', function () {
        if (this.checked && typeof window.analytics !== 'undefined') {
          const questionText = this.nextElementSibling.querySelector('.ia-section-faq-3__question-text').textContent;
          const faqIndex = this.closest('.ia-section-faq-3__item').getAttribute('data-faq-index');

          window.analytics.track('FAQ Expanded', {
            question: questionText,
            faqIndex: faqIndex,
          });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
